export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);

  // Format the date as "Month Day, Year" (e.g., "Jun 29, 2024")
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  return date.toLocaleDateString('en-US', options);
};

export function formatStringToTitleCase(input: string) {
  if (!input) return '';

  return input
    .toLowerCase() // Convert to lowercase
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
}
